module.exports = __webpack_public_path__ + "static/img/code.e03f29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/code.png
// module id = 1uhi
// module chunks = 1